module.exports = __webpack_public_path__ + "static/media/Designer-Ma-Myint-Zu.20f93278.png";